


















































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { defaultTimezone } from '@/services/config';
import { FormTargetingVO } from '@/model/FormWheel';
import { getQueryVariable } from '@/services/api';
import InfoPopover from '../components/InfoPopover.vue'

@Component({
  components: {
    'info-popover': InfoPopover
  }
})
class PopSetting extends Vue {
  @Prop(String)
  id?: string;

  @Prop(Object)
  rulesData!: any;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Object)
  targetingData!: FormTargetingVO;

  @Prop(String)
  activeTag?: string;

  rules = this.rulesData;
  targeting = this.targetingData;

  effectiveType = 'always'; // 生效类型：always-始终生效, custom-自定义生效时间

  // 自定义生效时间相关
  effectiveStartDate: string = '';
  effectiveStartTime: string = '';
  effectiveEndDate: string = '';
  effectiveEndTime: string = '';

  // 校验状态
  validation = {
    startDateError: false,
    startTimeError: false,
    endDateError: false,
    endTimeError: false,
    endTimeLogicError: false
  };

  // 时区信息
  get timezoneDisplay() {
    const timezone = localStorage.getItem('timezone') || defaultTimezone;
    return this.$tx('form.pop.tz', '应用店铺时区—{{timezone}}', { timezone });
  }

  get isAbtest() {
    return getQueryVariable('abtest') === 'true';
  }

  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  created() {
    this.initEffectiveTime();
  }

  private getShopTimezoneRaw() {
    return localStorage.getItem('timezone') || defaultTimezone;
  }

  private getShopZoneName() {
    // localStorage timezone 形如 "(GMT+08:00) Asia/Shanghai"
    const raw = this.getShopTimezoneRaw();
    return raw.split(' ')?.[1] || 'Asia/Shanghai';
  }

  private toShopMillis(date: string, timeWithSeconds: string) {
    const zone = this.getShopZoneName();
    const dt = DateTime.fromFormat(`${date} ${timeWithSeconds}`, 'yyyy-MM-dd HH:mm:ss', { zone });
    if (dt.isValid) return dt.toMillis();
    // 兜底：不阻塞校验（极端情况下格式不匹配）
    return new Date(`${date} ${timeWithSeconds}`).getTime();
  }

  initEffectiveTime() {
    // 从targeting初始化界面状态
    const type = this.targeting?.scheduleType;
    const startTime = this.targeting?.startTime;
    const endTime = this.targeting?.endTime;

    // 根据type或时间字段判断生效类型
    if (type === 1 || startTime || endTime) {
      this.effectiveType = 'custom';

      // 解析开始时间到界面字段
      if (startTime) {
        const parts = startTime.split(' ');
        this.effectiveStartDate = parts[0] || '';
        this.effectiveStartTime = parts[1] ? parts[1].substring(0, 5) : '';
      } else {
        this.effectiveStartDate = '';
        this.effectiveStartTime = '';
      }

      // 解析结束时间到界面字段
      if (endTime) {
        const parts = endTime.split(' ');
        this.effectiveEndDate = parts[0] || '';
        this.effectiveEndTime = parts[1] ? parts[1].substring(0, 5) : '';
      } else {
        this.effectiveEndDate = '';
        this.effectiveEndTime = '';
      }
    } else {
      // 默认始终生效
      this.effectiveType = 'always';
      this.effectiveStartDate = '';
      this.effectiveStartTime = '';
      this.effectiveEndDate = '';
      this.effectiveEndTime = '';
    }
  }

  changeEffectiveType(val: string) {
    (window as any).gtagClick?.('form_list_schedule', '弹窗_列表_生效设置');
    this.effectiveType = val;
    // 清除所有校验错误
    this.clearValidationErrors('all');

    if (val === 'always') {
      // 清空界面字段
      this.effectiveStartDate = '';
      this.effectiveStartTime = '';
      this.effectiveEndDate = '';
      this.effectiveEndTime = '';
    }
    // 如果是custom，界面字段已经在initEffectiveTime中初始化或保持原值

    this.updateEffectiveTime();
  }

  handleStartDateChange() {
    this.clearValidationErrors('startDate');
    this.updateEffectiveTime();
  }

  handleStartTimeChange() {
    this.clearValidationErrors('startTime');
    this.updateEffectiveTime();
  }

  handleEndDateChange() {
    this.clearValidationErrors('endDate');
    this.updateEffectiveTime();
  }

  handleEndTimeChange() {
    this.clearValidationErrors('endTime');
    this.updateEffectiveTime();
  }

  updateEffectiveTime() {
    if (!this.targeting) return;

    if (this.effectiveType === 'custom') {
      // 设置type为1（自定义时间）
      this.targeting.scheduleType = 1;

      // 组合开始时间
      if (this.effectiveStartDate && this.effectiveStartTime) {
        // el-time-select 返回的是 HH:mm 格式，需要转换为 HH:mm:ss
        const timeStr = this.effectiveStartTime.length === 5 ? `${this.effectiveStartTime}:00` : this.effectiveStartTime;
        this.targeting.startTime = `${this.effectiveStartDate} ${timeStr}`;
      } else if (this.effectiveStartDate) {
        this.targeting.startTime = `${this.effectiveStartDate} 00:00:00`;
      } else {
        delete this.targeting.startTime;
      }

      // 组合结束时间
      if (this.effectiveEndDate && this.effectiveEndTime) {
        // el-time-select 返回的是 HH:mm 格式，需要转换为 HH:mm:ss
        const timeStr = this.effectiveEndTime.length === 5 ? `${this.effectiveEndTime}:00` : this.effectiveEndTime;
        this.targeting.endTime = `${this.effectiveEndDate} ${timeStr}`;
      } else if (this.effectiveEndDate) {
        this.targeting.endTime = `${this.effectiveEndDate} 23:59:59`;
      } else {
        delete this.targeting.endTime;
      }
    } else {
      // 始终生效：设置type为0，清除时间字段
      this.targeting.scheduleType = 0;
      delete this.targeting.startTime;
      delete this.targeting.endTime;
    }

    // 触发targeting变更事件
    this.$emit('changeTargetingData', this.targeting);
  }

  // 校验生效时间
  validateEffectiveTime(): boolean {
    // 重置校验状态
    this.validation = {
      startDateError: false,
      startTimeError: false,
      endDateError: false,
      endTimeError: false,
      endTimeLogicError: false
    };

    const { effectiveType, effectiveStartDate, effectiveStartTime, effectiveEndDate, effectiveEndTime } = this;
    console.log('validateEffectiveTime', {
      effectiveType, effectiveStartDate, effectiveStartTime, effectiveEndDate, effectiveEndTime
    });

    if (this.effectiveType === 'custom') {
      // 1. 开始时间校验：日期、时间必填
      let hasError = false;
      if (!this.effectiveStartDate) {
        this.validation.startDateError = true;
        hasError = true;
      }
      if (!this.effectiveStartTime) {
        this.validation.startTimeError = true;
        hasError = true;
      }
      if (hasError) {
        this.$message.error(this.$tx('form.pop.err.needStart', '自定义生效时间需设置开始时间'));
        return false;
      }

      // 2. 结束时间校验：日期和时间要么都填，要么都不填
      const hasEndDate = !!this.effectiveEndDate;
      const hasEndTime = !!this.effectiveEndTime;
      if ((hasEndDate && !hasEndTime) || (!hasEndDate && hasEndTime)) {
        // 仅填写一项，为空项标红
        if (hasEndDate) {
          this.validation.endTimeError = true;
        } else {
          this.validation.endDateError = true;
        }
        this.$message.error(this.$tx('form.pop.err.endInvalid', '自定义生效时间结束时间设置异常'));
        return false;
      }

      // 3. 如果填写了完整的结束时间，校验时间逻辑
      if (hasEndDate && hasEndTime) {
        // el-time-select 返回的是 HH:mm 格式，需要转换为 HH:mm:ss
        const startTimeStr = this.effectiveStartTime.length === 5 ? `${this.effectiveStartTime}:00` : this.effectiveStartTime;
        const endTimeStr = this.effectiveEndTime.length === 5 ? `${this.effectiveEndTime}:00` : this.effectiveEndTime;
        // 按店铺时区做时间比较
        const startDateTime = this.toShopMillis(this.effectiveStartDate, startTimeStr);
        const endDateTime = this.toShopMillis(this.effectiveEndDate, endTimeStr);
        const currentTime = DateTime.now().setZone(this.getShopZoneName()).toMillis();

        // 结束时间不能早于开始时间 与 当前时间
        if (endDateTime <= startDateTime || endDateTime <= currentTime) {
          this.validation.endDateError = true;
          this.validation.endTimeError = true;
          this.validation.endTimeLogicError = true;
          this.$message.error(this.$tx('form.pop.err.range', '自定义生效时间设置异常'));
          return false;
        }
      }
    }
    return true;
  }

  // 清除校验错误状态
  clearValidationErrors(field?: 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'all') {
    if (!field || field === 'all') {
      this.validation = {
        startDateError: false,
        startTimeError: false,
        endDateError: false,
        endTimeError: false,
        endTimeLogicError: false
      };
    } else {
      switch (field) {
        case 'startDate':
          this.validation.startDateError = false;
          break;
        case 'startTime':
          this.validation.startTimeError = false;
          break;
        case 'endDate':
          this.validation.endDateError = false;
          this.validation.endTimeLogicError = false;
          break;
        case 'endTime':
          this.validation.endTimeError = false;
          this.validation.endTimeLogicError = false;
          break;
      }
    }
  }

  valid() {
    return this.validateEffectiveTime();
  }

  save() {
    if (this.valid()) {
      this.$emit('save');
    }
    (window as any).gtagClick?.('form_tool_enable', '弹窗_启用订阅工具');
  }

  saveDraft() {
    if (this.isAbtest) {
      if (!this.isEditAbTest) {
        return;
      }
    }
    if (this.valid()) {
      this.$emit('saveDraft');
    }
    (window as any).gtagClick?.('form_tool_save', '弹窗_保存订阅工具');
  }

  backStep() {
    if (this.valid()) {
      this.$emit('backStep');
    }
  }

  @Watch('rulesData')
  changerulesData(val: any) {
    this.rules = val;
    // rules对象不包含时间相关字段，时间字段都在targeting中
  }

  @Watch('targetingData')
  changetargetingData(val: any) {
    this.targeting = val;
    this.initEffectiveTime();
  }
}

export default PopSetting;
